import { WorldCountryCode } from '@/config/world-countries-en';
import { type DetailResult } from './type';
import mapNewZealand from './nz-address-mapping';
import mapAustralia from './au-address-mapping';
import mapUnitedKingdom from './uk-address-mapping';
import mapSingapore from './sg-address-mapping';

export interface AddressMapping {
    getAddress(): string;
    getPostcode(): string;
    getSuburb(): string;
    getStateRegionCity(): string;
}



type MappingServices = {
    [name: string]: {
        map(placeDetails: DetailResult): AddressMapping;
    };
}

const mappingServices: MappingServices = {
    nz: mapNewZealand,
    au: mapAustralia,
    gb: mapUnitedKingdom,
    sg: mapSingapore
}

class AddressMappingService {
    mapAddressFor(placeDetails: DetailResult, country: WorldCountryCode) {
        return mappingServices[country.toLocaleLowerCase()].map(placeDetails);
    }
}

export default new AddressMappingService();
